mutation DeleteMatchCampaign($id: ID!) {
  deleteMatchCampaign(input: { id: $id }) {
    success
  }
}
